export default "__VITE_ASSET__CcNYQisB__"